import { db } from '@/plugins/firebase'
import { firestoreAction } from 'vuexfire'

export default {
  fetchUser ({ commit }, user) {
    commit('SET_LOGGED_IN', user !== null)
    if (user) {
      commit('SET_USER', {
        displayName: user.displayName,
        email: user.email
      })
    } else {
      commit('SET_USER', null)
    }
  },
  closeModal ({ commit }, modal) {
    commit('CLOSE_MODAL', modal)
  },
  showModal ({ commit }, modal) {
    commit('SHOW_MODAL', modal)
  },
  bindUsers: firestoreAction(({ bindFirestoreRef }) => {
    return bindFirestoreRef('utilisateurs', db.collection('utilisateurs'))
  }),
  fetchSelectedUser ({ commit }, user) {
    if (user) {
      commit('EDIT_USER', user)
    } else {
      commit('EDIT_USER', null)
    }
  },
  bindApparts: firestoreAction(({ bindFirestoreRef }) => {
    return bindFirestoreRef('appartements', db.collection('appartements'))
  }),
  fetchSelectedAppart ({ commit }, appart) {
    if (appart) {
      commit('EDIT_APPART', appart)
    } else {
      commit('EDIT_APPART', null)
    }
  },
  bindGestion: firestoreAction(({ bindFirestoreRef }, idappart) => {
    return bindFirestoreRef('gestion', db.collection('gestions').doc(idappart))
  }),
  bindActualites: firestoreAction(({ bindFirestoreRef }) => {
    return bindFirestoreRef('actualites', db.collection('actualites'))
  }),
  bindDevis: firestoreAction(({ bindFirestoreRef }) => {
    return bindFirestoreRef('devis', db.collection('devis'))
  }),
  bindRealisations: firestoreAction(({ bindFirestoreRef }) => {
    return bindFirestoreRef('realisations', db.collection('realisations'))
  }),
  fetchSelectedImgzoom ({ commit }, imgzoom) {
    if (imgzoom) {
      commit('EDIT_IMGZOOM', imgzoom)
    } else {
      commit('EDIT_IMGZOOM', null)
    }
  },
  fetchSelectedActualite ({ commit }, actualite) {
    if (actualite) {
      commit('EDIT_ACTUALITE', actualite)
    } else {
      commit('EDIT_ACTUALITE', null)
    }
  },
  fetchSelectedDevis ({ commit }, devis) {
    if (devis) {
      commit('EDIT_DEVIS', devis)
    } else {
      commit('EDIT_DEVIS', null)
    }
  },
  fetchSelectedRealisation ({ commit }, realisation) {
    if (realisation) {
      commit('EDIT_REALISATION', realisation)
    } else {
      commit('EDIT_REALISATION', null)
    }
  },
  increase ({ commit, state }) {
    commit('increase', state.counter + 1)
  }
}
